import ViewsPrivacy from '@/views/privacy/ViewsPrivacy.vue';

import {home} from '@/router/breadcrumbs';
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: '/privacy',
        name: 'privacy',
        component: ViewsPrivacy,
        meta: {
            breadcrumbs: [home]
        }
    }
] as RouteRecordRaw[]
